const appDeploymentInputOption = {
  value: "APPDEPLOYMENT",
  label: "App Deployment",
};

export { appDeploymentInputOption };
